<template>
  <div>
    <vs-prompt
      :title="titleText"
      @cancel="val = ''"
      @accept="acceptAddNewTaskPrompt"
      @close="closeAddNewTaskPrompt"
      :active.sync="addNewTaskPrompt"
      :accept-text="titleText"
      :is-valid="validForm"
      class="eventPopup"
    >
      <vs-row>
        <vs-col vs-w="8">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Role</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <vs-select class="selectVenue" style="width: 100%" v-model="task_role">
                <div :key="item.id" v-for="item in selectableRoles">
                  <vs-select-item :value="item.id" :text="item.title" />
                </div>
              </vs-select>
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Task</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <vs-input class="inputx w-full" placeholder="Example: empty trash" v-model="task_title" />
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Note</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <vs-textarea class="inputx w-full" placeholder="Note" v-model="task_note" />
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Place</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <gmap-autocomplete
                class="addressInput vs-inputx vs-input--input normal"
                placeholder="Type location or address"
                @place_changed="updateAddress"
                :value="task_address"
                :select-first-on-enter="true"
              >
                <template v-slot:input="slotProps">
                  <v-text-field
                    outlined
                    prepend-inner-icon="place"
                    placeholder="Type location or address"
                    ref="input"
                    v-on:listeners="slotProps.listeners"
                    v-on:attrs="slotProps.attrs"
                  >
                  </v-text-field>
                </template>
              </gmap-autocomplete>
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Venues</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <vs-select multiple class="selectVenue" style="width: 100%" v-model="selectedVenues">
                <div :key="index" v-for="(item, index) in selectableVenues">
                  <vs-select-group :title="item.title" v-if="item.group">
                    <vs-select-item
                      :key="index"
                      :value="item.value"
                      :text="item.text"
                      v-for="(item, index) in item.group"
                    />
                  </vs-select-group>
                </div>
              </vs-select>
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Day</span>
            </div>
            <div class="vx-col sm:w-2/5 w-full">
              <flat-pickr
                :config="datePickerConfigStart"
                class="p-3 s-inputx vs-input--input flex"
                v-model="task_startDate"
                placeholder="Start..."
                style="display: flex; width: 100%"
              />
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full"></div>
            <div class="vx-col sm:w-2/5 w-full">
              <vs-checkbox v-model="task_notifyMe">Notify in LIFE app</vs-checkbox>
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Repeat</span>
            </div>
            <div class="vx-col sm:w-2/5 w-full">
              <vs-checkbox v-model="isRecurring">Repeat</vs-checkbox>
            </div>
          </div>

          <transition name="fade">
            <div class="vx-row mb-6" v-if="isRecurring">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Days</span>
              </div>
              <div class="vx-col sm:w-4/5 w-full" style="display: flex">
                <vs-checkbox
                  v-for="(day, index) in recurringDays"
                  :key="index"
                  v-model="selectedRecurringDays"
                  :vs-value="day.id"
                  >{{ day.name }}</vs-checkbox
                >
              </div>
            </div>
          </transition>

          <transition name="fade">
            <div class="vx-row mb-6" v-if="isRecurring">
              <div class="vx-col sm:w-1/5 w-full"></div>
              <div class="vx-col sm:w-4/5 w-full">
                <span style="color: #ccc">Repeats {{ recurringText }}</span>
              </div>
            </div>
          </transition>

          <div class="vx-row mb-6" v-if="isRecurring">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Stop repeat</span>
            </div>
            <div class="vx-col sm:w-2/5 w-full">
              <flat-pickr
                :config="datePickerConfig"
                v-model="task_endDate"
                placeholder="End..."
                style="display: flex; width: 100%"
                class="p-3 s-inputx vs-input--input flex"
              />
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Flagged</span>
            </div>
            <div class="vx-col sm:w-2/5 w-full">
              <feather-icon
                v-if="!task_flagged"
                icon="FlagIcon"
                svgClasses="w-6 h-6 hover:text-primary cursor-pointer"
                @click.stop="task_flagged = true"
              />
              <feather-icon
                v-if="task_flagged"
                icon="FlagIcon"
                svgClasses="w-6 h-6 text-warning cursor-pointer"
                @click.stop="task_flagged = false"
              />
            </div>
          </div>

          <!--<div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Responsible</span>
        </div>
        <div class="vx-col">
          <vs-input
            class="inputx w-full"
            placeholder="Full name"
            v-model="task_responsible"
          />
        </div>
      </div>-->

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Responsible</span>
            </div>
            <div class="vx-col sm:w-3/5 w-full">
              <TypeAhead
                v-model="data"
                classes="typeahead-container"
                :placeholder="placeholder"
                src=""
                :getResponse="getResponse"
                :selectFirst="selectFirst"
                :limit="parseInt(limit)"
                :queryParamName="queryParamName"
                :minChars="parseInt(minChars)"
                :delayTime="parseInt(delayTime)"
                :onHit="onHit"
                :highlighting="highlighting"
                :render="render"
                :fetch="fetch"
              ></TypeAhead>

              <div v-if="task_responsible_name !== ''">
                <vs-chip v-if="task_responsible_userId !== ''" color="success" class="mt-6 instructor-chip">
                  {{ task_responsible_name }}
                </vs-chip>
              </div>
            </div>
          </div>

          <div class="buttons-footer-left">
            <vs-button
              v-if="!isNew"
              color="danger"
              @click.native="confirmDelete"
              :type="!isRecurring ? 'border' : 'filled'"
              class=""
              >Delete{{ isRecurring ? "" : "" }}</vs-button
            >
          </div>
        </vs-col>
        <vs-col vs-w="4" class="px-5" vs-justify="center">
          <vs-row vs-justify="center">
            <h3>Image</h3>
            <TaskImages :venueTaskId="task_id" :imageUrls="task_imageUrls" style="width: 100%" />
          </vs-row>
        </vs-col>
      </vs-row>
    </vs-prompt>
  </div>
</template>

<script>
import _ from "lodash";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moment from "moment";

import { mapGetters } from "vuex";
import { RRule, RRuleSet, rrulestr } from "rrule";
import TypeAhead from "vue2-typeahead";
const TaskImages = () => import("./TaskImages.vue");

export default {
  components: {
    TaskImages,
    TypeAhead,
    flatPickr,
  },
  props: [],
  data() {
    const that = this;
    return {
      isNew: false,
      task_role: "",
      task_imageUrls: [],
      task_address: "",
      task_longitude: 0,
      task_latitude: 0,
      selectedVenues: [],
      task_flagged: false,
      task_notifyMe: false,
      // Typeahead
      data: "",
      selectFirst: false,
      limit: 10,
      queryParamName: ":keyword",
      minChars: 2,
      delayTime: 500,
      placeholder: "Please enter responsible name or email",
      classes: "typeahead",
      rruleConfig: {
        freq: RRule.WEEKLY,
        //interval: 5,
        //byweekday: [RRule.MO, RRule.FR],
        //dtstart: new Date(Date.UTC(2012, 1, 1, 10, 30)),
        //until: new Date(Date.UTC(2012, 12, 31)),
      },
      task_rrule: null,
      momentFormat: "DD-MM-YYYY HH:mm", // "DD-MM-YYYY HH:mm" for time
      selectedRecurringDays: [],
      recurringDays: [
        { id: 0, name: "Mon" },
        { id: 1, name: "Tue" },
        { id: 2, name: "Wed" },
        { id: 3, name: "Thu" },
        { id: 4, name: "Fri" },
        { id: 5, name: "Sat" },
        { id: 6, name: "Sun" },
      ],
      task_id: "",
      task_title: "",
      task_note: "",
      task_startDate: null,
      task_endDate: null,
      isRecurring: false,
      task_responsible_name: "",
      task_responsible_userId: "",
      addNewTaskPrompt: false,
      datePickerConfig: {
        enableTime: true, // Set to true for time again
        enableSeconds: false,
        noCalendar: false,
        time_24hr: true,
        dateFormat: "d-m-Y H:i", // "d-m-Y H:i" for time
        defaultHour: 12,
        defaultMinute: 30,
        defaultSecond: 0,
      },
      datePickerConfigStart: {
        enableTime: true, // Set to true for time again
        enableSeconds: false,
        noCalendar: false,
        time_24hr: true,
        dateFormat: "d-m-Y H:i", // "d-m-Y H:i" for time
        defaultHour: 12,
        defaultMinute: 30,
        defaultSecond: 0,
        onChange: function (selectedDates) {
          that.updateEndDate();
        },
      },
    };
  },
  computed: {
    ...mapGetters({
      activeVenue: "venues/activeVenue",
      userId: "users/userId",
      venues: "venues/venues",
      roles: "venueTasks/roles",
    }),
    selectableRoles() {
      return [
        {
          id: "",
          title: "Other Task",
        },
        {
          id: "vm",
          title: "Venue Manager Task",
        },
        {
          id: "sm",
          title: "Shift Manager Task",
        },
        {
          id: "hq",
          title: "Marketing Task",
        },
      ].filter(e => e.id != "hq" || this.roles.some(role => role.roleId == "hq")); // Can only select HQ if you have a HQ role
    },
    selectableVenues() {
      return _.chain(this.venues)
        .map(e => {
          return { ...e, text: e.name, value: e.venueId };
        })
        .groupBy(e => e.country)
        .map((v, k) => {
          //console.log("Name: ", k, "value", v)
          return { title: k, group: v };
        })
        .value();
    },
    validForm() {
      return (
        this.task_title !== "" &&
        this.task_startDate !== "" &&
        this.task_endDate !== "" &&
        // this.task_role !== "" && // "" just means "Other Tasks"
        (!this.isRecurring ||
          moment(this.task_endDate, this.momentFormat).isAfter(
            moment(this.task_startDate, this.momentFormat),
          ))
      );
    },
    titleText() {
      return (this.isNew ? "Add " : "Update ") + "task";
    },

    recurringText() {
      const rrule = new RRule({
        ...this.rruleConfig,
        byweekday: this.selectedRecurringDays,
        dtstart: moment.utc(this.task_startDate, this.momentFormat).toDate(),
        until: new Date(moment.utc(this.task_endDate, this.momentFormat).format()),
      });
      return rrule.toText();
    },
  },
  methods: {
    updateAddress: function (payload) {
      this.task_address = payload.formatted_address;
      const lat = payload.geometry.location.lat();
      const lng = payload.geometry.location.lng();

      this.task_latitude = lat;
      this.task_longitude = lng;

      /*this.street =
        this.getAddressComponent(payload, "route") +
        " " +
        this.getAddressComponent(payload, "street_number");
      this.city = this.getAddressComponent(payload, "locality");
      this.postalCode = this.getAddressComponent(payload, "postal_code");
      this.country = this.getAddressComponent(payload, "country");*/
    },

    getAddressComponent: function (address, component) {
      var result = address.address_components.filter(cmp => {
        if (cmp.types.includes(component)) {
          return true;
        }

        return false;
      });

      if (result.length == 0) {
        return "";
      }

      return result[0].long_name;
    },

    getResponse: function (response) {
      return response.data;
    },
    onHit: function (item, vue /*, index*/) {
      let current = vue.current;
      let selectedItem = vue.data[current];

      this.task_responsible_userId = selectedItem.userId;
      this.task_responsible_name = item;
    },
    highlighting: function (item, vue) {
      return item.toString().replace(vue.query, `<b>${vue.query}</b>`);
    },
    render: function (items /*, vue*/) {
      const titles = items.map(x => x.firstName + " " + x.lastName + " (" + x.email + ")");
      return titles;
    },
    fetch: function (/*url*/) {
      return this.$http.get(process.env.VUE_APP_API_BASE_URL + "/users?query=" + this.data);
    },

    updateEndDate() {
      this.task_endDate = this.task_startDate;
    },
    confirmDelete() {
      this.addNewTaskPrompt = false;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Delete task?",
        accept: this.deleteEvent,
      });
    },
    async deleteEvent() {
      console.log("Deleting task");
      this.$vs.loading();
      await this.$store.dispatch("venueTasks/deleteVenueTask", this.task_id);

      this.$vs.loading.close();
      this.$vs.notify({
        color: "danger",
        title: "Deleted task",
        text: "The task was deleted",
      });

      console.log("EMITTING", this, this.$emit);
      this.$root.$emit("venueTaskChanged");
    },
    show(date) {
      this.isNew = true;
      this.task_id = (Math.random() + 1).toString(36).substring(2);
      this.task_responsible_name = "";
      this.task_responsible_userId = "";
      this.selectedVenues = [];
      this.task_flagged = false;
      this.task_imageUrls = [];
      this.task_address = "";
      this.task_longitude = 0;
      this.task_latitude = 0;
      this.task_notifyMe = false;

      this.task_role = "";

      this.addNewTaskPrompt = true;
      // reset form
      this.data = "";

      this.selectedVenues.push(this.activeVenue.venueId);

      this.exclusionDays = [];
      this.task_rrule = null;

      this.selectedRecurringDays = [];

      this.task_title = "";
      this.task_note = "";

      this.isRecurring = false;
      this.task_responsible_name = "";
      this.task_responsible_userId = "";

      if (date) {
        this.task_startDate = date.format(this.momentFormat);
        this.task_endDate = date.clone().add(1, "week").format(this.momentFormat);
      } else {
        this.task_startDate = null;
        this.task_endDate = null;
      }
    },
    showWith(data) {
      console.log("Showing with task", data);
      this.isNew = false;
      this.task_id = data.venueTaskId;
      this.task_title = data.title;
      this.isRecurring = data.isRecurring;

      this.task_role = data.role;
      //this.rExclusionDates = data.rExclusionDatesUtcTicks;
      if (this.isRecurring) {
        const tRuleSet = rrulestr(data.rRule, { forceset: true });
        const tRule = tRuleSet.rrules()[0]; // important: assumes only one rule per set
        this.selectedRecurringDays = tRule.options.byweekday;
        this.exclusionDays = tRuleSet.exdates();
      }
      //this.selectedRecurringDays = data.rWeekDays;
      this.task_note = data.note;
      this.task_startDate = moment(data.startDateUtcTicks).format(this.momentFormat);
      this.task_endDate = moment(data.endDateUtcTicks).format(this.momentFormat);
      this.task_responsible_name = data.responsibleName;
      this.task_responsible_userId = data.responsibleUserId;
      this.selectedVenues = data.venueIds;
      this.task_flagged = data.flagged;
      this.task_imageUrls = data.imageUrls;
      this.task_address = data.address;
      this.task_longitude = data.longitude;
      this.task_latitude = data.latitude;
      this.task_notifyMe = data.notifyMe;
      this.addNewTaskPrompt = true;
    },
    remove(item) {
      this.task_tags.splice(this.task_tags.indexOf(item), 1);
    },
    async acceptAddNewTaskPrompt() {
      const event = {
        id: this.task_id,
        title: this.task_title,
        note: this.task_note,
        startDate: moment(this.task_startDate, this.momentFormat).format(), // valueOf for unix
        endDate: moment(this.task_endDate, this.momentFormat).format(),
        userId: this.userId,
        flagged: this.task_flagged,
        isRecurring: this.isRecurring,
        role: this.task_role,
        address: this.task_address,
        latitude: this.task_latitude,
        longitude: this.task_longitude,
        imageUrls: this.task_imageUrls,
        category: "", //TODO Deprecated
        responsibleName: this.task_responsible_name,
        responsibleUserId: this.task_responsible_userId,
        venueIds: this.selectedVenues,
        notifyMe: this.task_notifyMe,
      };

      if (this.isRecurring) {
        const rrule = new RRule({
          ...this.rruleConfig,
          byweekday: this.selectedRecurringDays,
          dtstart: moment.utc(this.task_startDate, this.momentFormat).toDate(),
          until: new Date(moment.utc(this.task_endDate, this.momentFormat).format()),
        });

        const rruleSet = new RRuleSet();

        // Add a rrule to rruleSet
        rruleSet.rrule(rrule);
        if (this.exclusionDays) this.exclusionDays.forEach(e => rruleSet.exdate(e));

        event.rRule = rruleSet.toString();
      }

      this.$vs.loading();
      try {
        if (!this.isNew) {
          console.log("Updating task", event);
          await this.$store.dispatch("venueTasks/updateVenueTask", event);
        } else {
          console.log("Adding task", event);
          await this.$store.dispatch("venueTasks/addVenueTask", event);
        }
        this.$root.$emit("venueTaskChanged");
        this.$emit("venueTaskChanged");

        this.$vs.notify({
          color: "success",
          title: "Task " + (!this.isNew ? "updated" : "added"),
          text: "Your task was " + (!this.isNew ? "updated" : "added"),
        });
      } catch (err) {
        console.error("Activation plan api call failed: " + err);
      } finally {
        this.$vs.loading.close();
      }
    },
    closeAddNewTaskPrompt() {},
  },
};
</script>

<style lang="scss" >
.addressInput {
  width: 100%;
}

.con-select-venue {
  display: flex;
  align-items: center;
  justify-content: center;
}
.con-select .vs-select {
  width: 100%;
}
@media (max-width: 550px) {
  .con-select {
    flex-direction: column;
  }
  .con-select .vs-select {
    width: 100%;
  }
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.smc-list-item {
  background: white;
  border-radius: 8px;
  border: 1px #efefef solid;
  box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    transform: translateY(-5px);
  }
}

.con-chips--remove-all {
  display: none;
}

.buttons-footer-left {
  position: absolute;
  bottom: 14px;
  z-index: 100;
  animation: fadeIn ease 500ms forwards;
  animation-delay: 500ms;
  opacity: 0;
}

.eventPopup.con-vs-dialog .vs-dialog {
  max-width: 1000px !important;
  position: relative;
}

.vs-select--label {
  font-size: 0.85rem;
  color: rgba(0, 0, 0, 0.6) !important;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.pac-container {
  z-index: 1000000;
}

.typeahead-container input {
  padding: 0.7rem !important;
  font-size: 1rem !important;
  color: inherit;
  position: relative;
  padding: 0.4rem;
  border-radius: 5px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.15);
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.15);
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
  width: 100%;
}

.instructor-chip {
  font-size: 14px;
}
.horizontal-row {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
</style>
